export enum Envs {
    Development = 'development',
    Staging = 'staging',
    Production = 'production',
}